import { render, staticRenderFns } from "./InformativeHighlightsMosaic.vue?vue&type=template&id=847bbba4&"
import script from "./InformativeHighlightsMosaic.vue?vue&type=script&lang=js&"
export * from "./InformativeHighlightsMosaic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports